import { TechnicalSubprocessObject } from './technical-subprocess-object.model';
import { ProcessActivityObject } from './process-activity-object.model';
import { StringUtils } from 'src/app/services/utils/string.utils';
import { TaskProcessObject } from 'src/app/models/orders/order-details-process/process-details/process-task.model';
import { isNullOrUndefined } from 'util';

export class ProcessDetailsObject {
  private fetched: boolean;

  constructor(private id: string, private startDate: Date, private endDate: Date, private activityList: Array<ProcessActivityObject>,
    private subprocessList: Array<TechnicalSubprocessObject>, private finished: boolean,
    private tasks: Array<TaskProcessObject>, fetched?: boolean) {
    this.fetched = isNullOrUndefined(fetched) ? true : fetched;
  }

  public static create(): ProcessDetailsObject {
    return new ProcessDetailsObject(StringUtils.NOT_AVALIABLE, new Date(), new Date(),
      new Array<ProcessActivityObject>(), new Array<TechnicalSubprocessObject>(), false, new Array<TaskProcessObject>(), false);
  }

  public getId(): string {
    return this.id;
  }

  public getStartDate(): Date {
    return this.startDate;
  }

  public getEndDate(): Date {
    return this.endDate;
  }

  public getActivityList(): Array<ProcessActivityObject> {
    return this.activityList;
  }

  public getSubprocessList(): Array<TechnicalSubprocessObject> {
    return this.subprocessList;
  }

  public setSubprocessList(technicalSubprocess: Array<TechnicalSubprocessObject>): void {
    this.subprocessList = technicalSubprocess;
  }

  public setFinished(finished: boolean): void {
    this.finished = finished;
  }

  public isFinished(): boolean {
    return this.finished;
  }

  public isFetched(): boolean {
    return this.fetched;
  }
}
